export default "__VITE_ASSET__f4tfc3e1__"